interface Task {
  id: number;
  priority: number;
  config: PriorityConfig;
  callback: () => void;
}

interface PriorityConfig {
  priority: number;
  delay?: number;
}

// IP ban> 活动activity>banter>大于安全项security
export const PRIORITY_LEVELS = {
  LEVEL_DEFAULT: 0,
  LEVEL_100: 100, // 安全项security
  LEVEL_200: 200, // banter
  LEVEL_400: 400, // IP ban
  LEVEL_450: 450, // 回归用户弹框 优先级仅高于活动弹框
  LEVEL_460: 460, // 'InviteEarnDepositReminderPopup',
  LEVEL_500: 500, // 活动activity
  LEVEL_600: 600, // 安全提示SafetyTipsDialog
};

class TaskManager {
  private queue: Task[];
  private currentTask: Task | null;
  private idCounter: number;
  private timer: NodeJS.Timeout | null;

  constructor() {
    this.queue = [];
    this.currentTask = null;
    this.idCounter = 0;
    this.timer = null;
  }

  addTask(config: PriorityConfig, callback: () => void): () => void {
    const id = this.idCounter++;
    const task: Task = {
      id,
      priority: config.priority || PRIORITY_LEVELS.LEVEL_DEFAULT,
      config: config,
      callback,
    };

    // console.log('---addTask', task.priority, id);
    this.queue.push(task);
    this.queue.sort((a, b) => b.priority - a.priority);

    this.processQueue();
    return () => this.releaseTask(id);
  }

  private releaseTask(taskId: number): void {
    // 清理当前任务
    // const task = this.queue.find((task) => task.id == taskId);
    // console.log('---releaseTask', task?.priority, taskId);

    if (this.currentTask && this.currentTask.id === taskId) {
      this.currentTask = null;
    }

    // 从队列中移除任务
    this.queue = this.queue.filter((task) => task.id !== taskId);

    // 继续处理队列
    this.processQueue();
  }

  private clearTimer(): void {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }

  private processQueue(): void {
    // 防止并发处理
    if (this.currentTask || this.queue.length === 0 || this.timer) return;
    // this.clearTimer();
    const fn = () => {
      this.timer = null;
      if (this.queue.length > 0) {
        this.currentTask = this.queue.shift()!;
        try {
          this.currentTask.callback();
        } catch (error) {
          console.error('Task execution error:', error);
          // 继续处理下一个任务
          this.currentTask = null;
          this.processQueue();
        }
      }
    };

    this.timer = setTimeout(fn, 100);
  }

  // 新增：清理所有任务
  destroy() {
    this.clearTimer();
    this.queue = [];
    this.currentTask = null;
  }
}

// demo
const taskManager = new TaskManager();
export default taskManager;

// function tesManager() {
//   console.log("开始测试 TaskManager 抢占机制...\n");

//   // 低优先级任务
//   const releasePermission1 = manager.addTask({ priority: 1 }, () => {
//     console.log("🟦 执行低优先级任务 (priority: 1)");
//     // 模拟任务执行时间
//     setTimeout(() => {
//       releasePermission1();
//       console.log("✅ 低优先级任务完成\n");
//     }, 5000);
//   });

//   // 1秒后添加高优先级任务，应该抢占低优先级任务
//   setTimeout(() => {
//     console.log("➕ 添加高优先级任务...");
//     const releasePermission2 = manager.addTask({ priority: 3 }, () => {
//       console.log("🔴 执行高优先级任务 (priority: 3) - 抢占成功!");
//       setTimeout(() => {
//         releasePermission2();
//         console.log("✅ 高优先级任务完成\n");
//       }, 2000);
//     });
//   }, 1000);

//   // 2秒后添加中等优先级任务
//   setTimeout(() => {
//     console.log("➕ 添加中等优先级任务...");
//     const releasePermission3 = manager.addTask(
//       { priority: 2, delay: 100 },
//       () => {
//         console.log("🟡 执行中等优先级任务 (priority: 2, delay: 100ms)");
//         setTimeout(() => {
//           releasePermission3();
//           console.log("✅ 中等优先级任务完成\n");
//         }, 300);
//       },
//     );
//   }, 2000);
// }

export { TaskManager };
// 取消注释下面这行来运行测试
